<div
  class="relative w-full h-full flex"
  [ngClass]="{
    'flex-row': layoutService.deviceMode === 'horizontal',
    'flex-col': layoutService.deviceMode === 'vertical',
  }"
>
  <!-- Main Dom  -->
  <div
    class="relative h-full flex flex-col"
    [ngStyle]="{
      width: layoutService.getMainDomWidth(),
      height: layoutService.getMainDomHeight(),
    }"
  >
    @if (!selectedTool) {
      <screen-control-bar
        [canvasController]="canvasController"
        [projectController]="ProjectController"
        [isAutoRotate]="true"
        [isScreenShot]="true"
        [isTheme]="true"
        [isFirstCameraPosition]="true"
      >
      </screen-control-bar>
    }

    @if (selectedTool?.name === 'Part') {
      <cart-button></cart-button>
      <selected-part-list-bar [row]="true"></selected-part-list-bar>
    }
    @if (selectedTool?.name === 'AI') {
      <button
        class="absolute bottom-2 right-2 w-6 lg:w-10 h-6 lg:h-10 rounded-full p-1 flex justify-center items-center bg-white/60 dark:bg-black/60 z-[20]"
        (click)="chatReset()"
      >
        <div
          class="flex justify-center items-center text-black dark:text-white text-base lg:text-xl"
        >
          <mat-icon [inline]="true">restart_alt</mat-icon>
        </div>
      </button>
    }

    <back-button
      [selectedTool]="selectedTool"
      [title]="project?.title"
      (clearToolData)="onClickBack($event)"
    ></back-button>

    <!-- 3D Dom -->
    <div
      class="relative w-full flex-none"
      (drop)="onDragDrop($event)"
      (dragover)="$event.preventDefault()"
      [ngStyle]="{
        width: layoutService.getThreeRenderWidth(),
        height: layoutService.getThreeRenderHeight(),
      }"
    >
      <tool-select-bar
        [project]="project"
        [isLoading]="isLoading"
        [isNameHide]="selectedTool !== undefined"
        [selectedTool]="selectedTool"
        (changeSelectedTool)="onToolSelect($event)"
      ></tool-select-bar>
      <router-outlet></router-outlet>
    </div>

    <part-category-bar
      [ngStyle]="{ height: layoutService.getBottomBarHeight() }"
      [selectedCategory]="selectedPartCategory"
      (onClickBottomButton)="onClickPartCategory($event)"
    ></part-category-bar>

    <part-grid-list
      [ngStyle]="{ height: layoutService.getBottomEditerBarHeight() }"
      [selectedCategoryIndex]="selectedPartCategoryIndex"
      (selectedAddPart)="onSelectedAddPart($event)"
      (selectedAddCart)="onSelectedAddCart($event)"
    ></part-grid-list>
  </div>

  <!-- Side Bar -->
  <div
    class="relative flex-none flex flex-col bg-white dark:bg-black"
    [ngStyle]="{
      width: layoutService.getSideBarWidth(),
      height: layoutService.getSideBarHeight(),
    }"
  >
    @if (selectedTool?.slug !== 'Part') {
      <div class="w-full py-2 flex justify-center items-center">
        <p class="text-black dark:text-white text-lg lg:text-xl">{{ selectedTool?.slug }}</p>
      </div>
    }
    @if (isLoading) {
      <tool-loading></tool-loading>
    }
    @switch (selectedTool?.slug) {
      @case ('Wrap') {
        <wrap-tool></wrap-tool>
      }
      @case ('Sticker') {
        <sticker-tool></sticker-tool>
      }
      @case ('Livery') {
        <livery-tool></livery-tool>
      }
      @case ('AI agent') {
        <ai-agent-tool></ai-agent-tool>
      }
      @case ('Garage') {
        <garage-tool></garage-tool>
      }
      @case ('Preset') {
        <preset-tool [project]="project"></preset-tool>
      }
    }
  </div>
</div>
